import i18n from '@/main';

export default class OptionsRuler {
    static get DEFAULT() {
        return {
            escapeMessage: i18n?.t('mensagens.menuMapa.escParaCancelar'),
            lineStyle: {
                color: '#93CE1C',
                dashArray: false
            },
            circleMarker: {
                color: '#93CE1C',
                radius: 2
            },
            lengthUnit: {
                display: 'km',
                decimal: 2,
                factor: null,
                label: i18n?.t('mensagens.menuMapa.distancia')
            },
            angleUnit: {
                display: '&deg;',
                decimal: 2,
                factor: null,
                label: i18n?.t('mensagens.menuMapa.angulo')
            }
        };
    }
}
